export const INFOBOX_IDS = {
  actual: 'infobox-actual',
  comparison: 'infobox-comparison',
  growth: 'infobox-growth',
  diff: 'infobox-diff',
  comboActual: 'infobox-combo-actual',
  comboComparison: 'infobox-combo-comparison',
  comboGrowth: 'infobox-combo-growth',
  comboDiff: 'infobox-combo-diff',
  sparkline: (i: number) => `infobox-sparkline-${i}`
}

export const SPARKLINE_PREFIX = 'infobox-sparkline-'
